import CartPage from "../../components/Cart/CartPage";

const CartContainer = ({ isMobileVersion }) => {
  return <CartPage isMobileVersion={isMobileVersion} />;
};

export default CartContainer;
